import { Breadcrumbs as MBreadcrumbs } from "@mantine/core";
import clsx from "clsx";
import Link from "next/link";

type BreadcrumbsProps = {
  items: Record<"title" | "href", string>[];
};

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  return (
    <MBreadcrumbs separator=">">
      {items.map(({ title, href }, index) => (
        <Link
          href={href}
          passHref
          key={index}
          className={clsx(
            index === items.length - 1 ? "text-primary" : "text-gray-500",
            "hover:opacity-70",
          )}
        >
          {title}
        </Link>
      ))}
    </MBreadcrumbs>
  );
};
